(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drbell-book"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.db .countdown[data-release]').forEach((el) => {
  const release = new Date(el.dataset.release);
  const tick = () => {
    const ms = release - new Date();
    if (ms <= 0) { el.innerHTML = '<span class="label"><b>Available now.</b></span>'; return; }
    el.querySelector('[data-d]').textContent = Math.floor(ms / 864e5);
    el.querySelector('[data-h]').textContent = String(Math.floor(ms / 36e5) % 24).padStart(2, '0');
    el.querySelector('[data-m]').textContent = String(Math.floor(ms / 6e4) % 60).padStart(2, '0');
  };
  tick(); setInterval(tick, 30000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drbell-docuseries"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (e) => {
  const b = e.target.closest('.ep-play');
  if (!b) return;
  const f = document.createElement('iframe');
  f.src = 'https://drive.google.com/file/d/' + b.dataset.drive + '/preview';
  f.allow = 'autoplay; fullscreen'; f.allowFullscreen = true; f.title = b.getAttribute('aria-label');
  b.closest('.ep-frame').replaceChildren(f);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drbell-praise"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (e) => {
  const b = e.target.closest('.db .praise .slider-ctrl button');
  if (!b) return;
  const track = b.closest('.praise').querySelector('.track');
  const card = track.firstElementChild.getBoundingClientRect().width + 24;
  track.scrollBy({ left: card * Number(b.dataset.dir), behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drbell-stories"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (e) => {
  const b = e.target.closest('.db .story');
  if (b) {
    const dlg = b.closest('.db').querySelector('.story-dlg');
    dlg.querySelector('.dlg-content').replaceChildren(document.getElementById('story-' + b.dataset.story).content.cloneNode(true));
    dlg.setAttribute('aria-label', b.querySelector('h3').textContent);
    dlg.showModal(); dlg.scrollTop = 0;
    return;
  }
  const dlg = e.target.closest('.db .story-dlg');
  if (dlg && (e.target === dlg || e.target.closest('.close'))) dlg.close();
  else if (e.target.closest('.db .story-dlg a[href^="#"]')) e.target.closest('.story-dlg').close();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
